import { Form, Input, Row, Typography, Col } from "antd";
import TextArea from "antd/es/input/TextArea";
import React from "react";
import { labelConfig } from "../../../customer/customer.config";
import { BOM } from "../../../../services/definedMethod";

const { Text } = Typography;

const DetailsForm = (props) => {
  const { onFinish, form, initialValues } = props;

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      initialValues={initialValues}
      form={form}
    >
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Product Name</Text>}
            name={"name"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(labelConfig.productName)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Short Name</Text>}
            name={"shortName"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input
              maxLength={4}
              placeholder={BOM.handlePlaceholderMsg(labelConfig.shortName)}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Description</Text>}
            name={"description"}
            rules={[
              {
                type: "string",
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <TextArea
              placeholder={BOM.handlePlaceholderMsg(labelConfig.description)}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default DetailsForm;
